goog.provide("Ntry.ObjectPopup");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.ObjectPopup = {
    setPopupLayout: function (popup) {
        this.content_ = Entry.Dom('div', {
            class:'entryPopupHelperContent'
        });
        popup.popupWrapper_.append(this.content_);
        popup.addClass('objectPopupWindow');
        this.setContent(this, popup);
    },
    setContent: function (parent, popup) {
        if(this.object.length === 1) {
            parent.content_.addClass('singleItem');
            popup.css('height', '219px');
        } else {
            parent.content_.addClass('multiItem');
            popup.css('height', (93 + (this.object.length * 107) + 9) + 'px');
        }

        this.object.forEach(function (obj, i) {
            var dom = Entry.Dom('div');
            if(i > 0) {
                dom.css('margin-top', '25px');
            }
            var objDom = Entry.Dom('div');
            objDom.addClass(obj.class);

            var equalDom = Entry.Dom('div', {
                class: 'equal'
            });
            var textDom = Entry.Dom('div', {
                class: 'objectText'
            });

            if(obj.type === 'small') {
                objDom.css('width', '82px');
                objDom.css('margin-left', '35px');
            } else {
                objDom.css('width', '162px');
                popup.css('width', '480px');
                parent.content_.css('paddingLeft', '35px');
            }
            textDom.text(obj.text);
            dom.append(objDom);
            dom.append(equalDom);
            dom.append(textDom);
            parent.content_.append(dom);
        });
    }
};